import { Clipboard } from "@angular/cdk/clipboard";
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ProductService } from "src/app/shared/services/product.service";

@Component({
  selector: "app-ticket-coupon",
  templateUrl: "./ticket-coupon.component.html",
  styleUrls: ["./ticket-coupon.component.scss"],
})
export class TicketCouponComponent implements OnInit {
  @Input() activeCouponesList: any = [];

  @ViewChildren("ticketItem") ticketItems!: QueryList<ElementRef>;

  perforationSize = 30;
  perforationArrays: { [key: string]: number[] } = {};
  constructor(
    private toastrService: ToastrService,
    private clipboard: Clipboard,
    public productService: ProductService
  ) {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes["activeCouponesList"]) {
      setTimeout(() => {
        this.ticketItems.forEach((_, index) => this.updatePerforations(index));
      }, 50);
    }
  }

  updatePerforations(index: number) {
    const ticketElement = this.ticketItems.toArray()[index]?.nativeElement;
    if (ticketElement) {
      const height = ticketElement.clientHeight;
      const count = Math.floor(height / this.perforationSize);
      this.perforationArrays[index] = Array(count).fill(0);
      console.log("perforationArrays", this.perforationArrays);
    }
  }

  toggleDetails(coupon: any, index: number) {
    coupon.isExpanded = !coupon.isExpanded;
    setTimeout(() => this.updatePerforations(index), 50);
  }

  copyCouponCode(code: string) {
    this.clipboard.copy(code);
    let coppyMessage =
      localStorage.getItem("front-lang") == "ar"
        ? "تم نسخ الكود بنجاح"
        : "Coupone Code Moved To Clipboard";
    this.toastrService.success(coppyMessage);
  }

  isOfferValid(endDate: string): boolean {
    if (!endDate) return false;
    const now = new Date();
    const offerEndDate = new Date(endDate);
    return offerEndDate > now;
  }
}
